import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of, Subject} from 'rxjs';
import {Cam} from 'onvif';

@HookClass('camera')
export class CameraHook extends BaseHook {

    @Hook('94bab718-5919-42a0-b7fa-5be66293f6d0')
    public onCameraEvent(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const result$ = new Subject<any>();

        console.log('Connecting to camera...');
        // Connect to camera
        const camera = new Cam({
            hostname: inputArtifact.object.config.hostname,
            username: inputArtifact.object.config.username,
            password: inputArtifact.object.config.password,
            port: inputArtifact.object.config.port,
            timeout: inputArtifact.object.config.timeout,
            preserveAddress: inputArtifact.object.config.preserveAddress
        }, function(err: any) {
            if (err) {
                console.error('Failed to connect to camera:', err);
                throw err;
            }

            console.log('Successfully connected to camera!');

            // Get Snapshot URI (we will reuse it)
            camera.getSnapshotUri({}, (err: any, result: any) => {
                if (err) {
                    console.error('Failed to get snapshot URI:', err);
                    return;
                }
                const snapshotUri = result.uri;
                console.log('Snapshot URI:', snapshotUri);

                // Subscribe to events
                console.log('Subscribing to camera events...');
                camera.on('event', (event: any, xml: any) => {
                    try {
                        const logTime = new Date().toISOString();
                        const topicStr = event.topic && event.topic._;
                        const isMotionEvent = topicStr && topicStr.includes('Motion');

                        console.log(`[${logTime}] Received event: ${topicStr}}`);

                        if (isMotionEvent) {
                            const output: any = new NickProcessArtfact();
                            output.kind = ArtfactKind.ANY;
                            output.object = {
                                event,
                                xml,
                                snapshotUri
                            };

                            result$.next(output);
                        }
                    } catch (e) {
                        console.error('  Error handling event:', e);
                    }
                });
            });
        });

        // setTimeout(()=>{camera.removeAllListeners('event');}, 10000);

        return result$;
    }

}
